import { render, staticRenderFns } from "./ConfigField.vue?vue&type=template&id=35ae3d74"
import script from "./ConfigField.vue?vue&type=script&lang=js"
export * from "./ConfigField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports